import { ApiAccountCustomServiceFee, AccountCustomServiceFee } from '@types'

export const pResponseCustomServiceFee = (
  data: ApiAccountCustomServiceFee,
): AccountCustomServiceFee => {
  return {
    id: data.id,
    accountId: data.account_id,
    serviceFeeType: data.service_fee_type,
    feeDescription: data.fee_description,
    valueCalculationType: data.value_calculation_type,
    value: data.value,
    percentValue: data.percent_value,
    isTaxExempt: data.is_tax_exempt,
    itemTaxCode: data.item_tax_code,
  }
}
